import { stringToNumber } from '@razlet/utils';
import { resolveVolumePrecision, roundVolume } from '~/utils/volume';

export default class VWMeasurements {
  data = null;

  constructor (data, company) {
    this.data = data;
    this.company = company;
  }

  get weight () {
    return Math.round(this.data.weight);
  }

  get volume () {
    const volume = stringToNumber(this.data.volume);
    if (!Number.isFinite(volume)) return 0;
    const precision = resolveVolumePrecision({ company: this.company });
    return Math.sign(volume) * roundVolume(Math.abs(volume), precision);
  }
};
